var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6474 5.64725L5.53688 0.503859L6.03756 -1.77899e-06L12 5.99977L6.03756 12L5.53688 11.4703L10.6451 6.35303L-1.39933e-05 6.35303L-1.39544e-05 5.64725L10.6474 5.64725Z",
  fill: "#4585FF"
})));
export default SvgIconArrow;